module.exports = __webpack_public_path__ + "static/media/landscape.1117c270.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/uncomp/landscape.png
// module id = 56
// module chunks = 0